// extracted by mini-css-extract-plugin
module.exports = {"main":"CourseTitle_main__3SDcF","heading":"CourseTitle_heading__2oemn","img_container":"CourseTitle_img_container__2KOki","cross":"CourseTitle_cross__b8Q3Q"};